import { NgModule } from '@angular/core';
import { HttpClientTestingModule } from '@angular/common/http/testing';
import { RouterTestingModule } from '@angular/router/testing';

@NgModule({
  imports: [RouterTestingModule, HttpClientTestingModule],
})
export class BaseTestingModule {}
